import React from "react";
import Modal from "../UIComponents/CustomModal/Modal";

const CompanySwitchModal = (props) => {
    return (
        <Modal show={props.open}>
            <Modal.Header hideCloseIcon={true}>Company Switched</Modal.Header>
            <Modal.Content style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span>Please reload the page as company was switched in another tab</span>
            </Modal.Content>
            <Modal.Actions>
                <Modal.ActionButton filled onClick={() => window.location.reload()}>
                    Reload
                </Modal.ActionButton>
            </Modal.Actions>
        </Modal>
    );
};

export default CompanySwitchModal;
